var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('fa',{staticClass:"has-text-success",attrs:{"icon":"check"}}):_c('fa',{staticClass:"has-text-danger",attrs:{"icon":"times"}})
}
var staticRenderFns = []

export { render, staticRenderFns }